import { ReactElement } from 'react'
import MapOutlinedIcon from '@mui/icons-material/MapOutlined'
import { Box } from '@mui/material'
import { CollapsibleBoxInternalState } from '@ui/structure'
import { roofStoreyKey } from '@editorStores'
import { useModelStoreys } from '@editorHooks'
import CombinedPositionPlanDxfItem from './components/CombinedPositionPlanDxfItem'
import SingleStoreyPositionPlanDxfItem from './components/SingleStoreyPositionPlanDxfItem'
import { storeysTopToBottom } from './utils'

const PositionPlanDxf = (): ReactElement => {
  const storeys = useModelStoreys()
  const floorsTopToBottom = storeysTopToBottom(storeys).filter(storey => storey !== roofStoreyKey)

  return (
    <CollapsibleBoxInternalState
      variant="expander"
      label="Positionsplan DXF"
      dataCy="position-plan-dxf"
      defaultExpanded
      startIcon={<MapOutlinedIcon sx={{ color: 'grey.600', padding: '2px' }} />}
    >
      <Box>
        <CombinedPositionPlanDxfItem />
        {floorsTopToBottom.map(storey => (
          <SingleStoreyPositionPlanDxfItem key={storey} storey={storey} />
        ))}
      </Box>
    </CollapsibleBoxInternalState>
  )
}

export default PositionPlanDxf
